import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService } from '@app-auth/services/authentication.service';
import { API } from '@app-core/constants/api.constants';
import { AWS_COGNITO_REGION_KEY } from '@app-core/constants/constants';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { LoginTypes } from '@app-core/services/google-tag-manager/google-tag-manager.service';
import { StorageService } from '@app-core/services/storage/storage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-master-login',
  templateUrl: './master-login.component.html',
  styleUrls: ['./master-login.component.scss'],
})
export class MasterLoginComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private accessService: AccessService,
    public authService: AuthenticationService,
    private dataService: DataService,
    private storageService: StorageService
  ) {}

  public ngOnInit() {
    this.listenParams();
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private listenParams() {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: any) => this.validateCode(params));
  }

  private validateCode({ code, state = '' }) {
    if (code && state) {
      const [inputCustomerName, inputFleetId, region] = state.split(' ');
      if (typeof region === 'string' && region.trim() !== '') {
        this.storageService.setStorageValue(AWS_COGNITO_REGION_KEY, region);
      }
      console.log('region', region);
      API.refreshRegion(region);
      this.authService
        .intermediateServerMasterLoginAs({
          code,
          customerName: inputCustomerName,
          fleetId: inputFleetId,
        })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (loginInfo: any) => {
            this.accessService.setLoginInfo(loginInfo);
            this.dataService.userLogin.next({ loginInfo, redirectUrl: 'home', loginType: LoginTypes.master });
          },
          () => {
            this.router.navigate(['callback']);
          }
        );
    } else if (this.accessService.hasValidToken()) {
      this.dataService.userLogin.next();
    } else {
      this.router.navigate(['callback']);
    }
  }
}
